import { render, staticRenderFns } from "./PersonalTripList.vue?vue&type=template&id=ff37daba&scoped=true&"
import script from "./PersonalTripList.vue?vue&type=script&lang=js&"
export * from "./PersonalTripList.vue?vue&type=script&lang=js&"
import style0 from "./PersonalTripList.vue?vue&type=style&index=0&id=ff37daba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff37daba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
